import React from 'react';
import toast, { Toaster } from 'react-hot-toast';

import {confirmAlert} from "react-confirm-alert";
import Role from "../../../../inc/Role";
import {NavLink, useNavigate} from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import {Config} from '../../../../Config'
import Select from 'react-select'
import * as Utils from "../../../../inc/Utils";
import moment from "moment-timezone";

export default function GroupSpecialItemCreate(props) {
    const roles = new Role();
    let userId = roles.loginUserId;

    let btnTextDefault = 'บันทึกข้อมูล';
    let btnTextLoading = 'กำลังบันทึก..';
    let [isLoading, setLoading] = React.useState(false);
    let [agency, setAgency] = React.useState('');
    let [adsNaming, setAdsNaming] = React.useState('');
    let [agencyId, setAgencyId] = React.useState(null);
    let [kolPage, setKolPage] = React.useState(null);
    let [statusChecked, setStatusChecked] = React.useState(true);
    let [platform, setPlatform] = React.useState(null);
    let [platformId, setPlatformId] = React.useState(null);

    let [itemFreeForm, setItemFreeForm] = React.useState('');
    let [itemSelected, setItemSelected] = React.useState('');

    const navigate = useNavigate();

    let refName = React.useRef();

    React.useEffect(() => {
        (async function() {
            try {
                //region default kol id
                const resKolPage = await Utils.getKol();
                setKolPage(resKolPage);

                const resPlatform = await Utils.getPlatformAll();
                setPlatform(resPlatform);

                //region set new agency
                const resAgency = await Utils.getAgencySlug();
                let newAgencies = [];
                if(resAgency) {
                    let newA = resAgency.find(e => e.id === roles.agencyId).items;
                    let ownerIds = [];
                    for(let a of newA) {
                        ownerIds.push(a.ownerId);
                    }
                    for(let ag of resAgency) {
                        if(ag.items.find(e => ownerIds.includes(e.ownerId))) {
                            newAgencies.push({
                                id: ag.id,
                                slug: ag.slug,
                                name: ag.name
                            })
                        }
                    }
                }
                setAgency(newAgencies);
                //endregion

                if(props.generateGroupCampaignId) {
                    const resView = await getView(props.generateGroupCampaignId);
                    setStatusChecked(resView.status===1);
                    setAgencyId(newAgencies.filter(e => e.id === resView.agencyId)[0]);
                    setPlatformId(resPlatform.filter(e => e.id === resView.adsPlatformId)[0]);
                    refName.current.value = resView.name;

                    let sourceTypeSelectedIds = [];
                    if(resView) {
                        let items = resView.items;
                        if(items) {
                            for(let rs of items) {
                                let adsNamingSourceId = rs.adsNamingSourceId;
                                if(adsNamingSourceId) {
                                    if(rs.inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                                        sourceTypeSelectedIds.push(adsNamingSourceId + ':KOL' + rs.adsNamingId);
                                    }
                                    else {
                                        sourceTypeSelectedIds.push(adsNamingSourceId);
                                    }
                                }
                                else if(rs.inputType === Utils.ADSNAMING_TYPE_FREEFORM) {
                                    setItemFreeForm(items.filter(e => e.inputType === Utils.ADSNAMING_TYPE_FREEFORM)[0].text);
                                }
                            }
                        }
                        setItemSelected(sourceTypeSelectedIds);
                    }
                }
                else {
                    setAgencyId(newAgencies.filter(e => e.id === roles.agencyId)[0]);
                }

                const resAdsNaming = await Utils.getAdsNamingCampaign();
                if(resAdsNaming.length > 0) {
                    resAdsNaming.map((rs, index2) => {
                        let inputType = rs.inputType;
                        if(inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                            let newKolPageId = [];
                            if(resKolPage) {
                                for(let row of resKolPage) {
                                    let json  = {
                                        id: row.id + ':KOL' + rs.id,
                                        name:  row.name
                                    };
                                    newKolPageId.push(json);
                                }
                                rs.source = newKolPageId;
                            }
                        }
                    });
                    setAdsNaming(resAdsNaming);
                }
            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    async function getView(id) {
        const response = await fetch(Config.url.API_URL +'/api/generateGroupCampaign/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                id: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onCreate = async () => {

        let param = await getParams();
        let name = refName.current.value;

        if(!name) {
            toast.error("กรุณาระบุ ชื่อ Campaign");
            refName.current.focus();
        }
        else if(!agencyId) {
            toast.error("กรุณาระบุ Agency");
        }
        else if(!param.success) {
            toast.error("กรุณาเลือก Parameters ให้ครบถ้วน");
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: () => {
                            setLoading(true);

                            let statusChecked = document.getElementsByName('statusChecked');

                            const body = {
                                sourceTypeIds: param.data,
                                name: name,
                                generateGroupId: props.generateGroupId,
                                agencyId: agencyId ? agencyId.id : null,
                                adsPlatformId: platformId ? platformId.id:null,
                                status: statusChecked[0].checked ? 1:0,
                                createdBy: userId,
                                createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                            };

                            let url = Config.url.API_URL +'/api/generateGroupCampaign/create';
                            if(props.generateGroupCampaignId) {
                                body.id = props.generateGroupCampaignId;
                                url = Config.url.API_URL +'/api/generateGroupCampaign/update';
                            }

                            fetch(url, {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(response => {
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success("บันทึกข้อมูลเรียบร้อย");
                                    setTimeout(function () {
                                        navigate(props.backPath, {replace: true});
                                    }, 1500);
                                }
                                else {
                                    setLoading(false);
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    const onChangeAgencyId = (obj) => {
        setAgencyId(obj);
    };

    const onChangePlatformId = async (platformRow) => {
        setPlatformId(platformRow);
    };

    async function getParams() {
        let textParams = [];
        let sourceIds = [];
        let kolIds = [];

        //STEP 1 : Find Selected
        let sourceTypeIds = [];
        let sourceTypeAllIds = [];
        let selectSourceTypeIds = document.getElementsByName('sourceTypeIds[]');
        if(selectSourceTypeIds) {
            for(let st of selectSourceTypeIds) {
                let sourceTypeId = st.value;
                if(sourceTypeId) {
                    //STEP 1.1 : Find special selector
                    if(sourceTypeId.includes(':KOL')) {
                        let sp = sourceTypeId.split(':KOL');
                        let kolId = sp[0];
                        let adsNamingId = sp[1];
                        if(kolId) {
                            let find = kolPage.find(rs => {
                                if(parseInt(rs.id) === parseInt(kolId)) {
                                    return rs;
                                }
                            });
                            kolIds.push({
                                adsNamingSourceId: parseInt(kolId),
                                adsNamingId: parseInt(adsNamingId),
                                name: find ? find.name : null,
                                inputType: Utils.ADSNAMING_TYPE_KOL_PAGE
                            });
                        }
                    }
                    else {
                        sourceTypeIds.push(sourceTypeId);
                    }
                    sourceTypeAllIds.push(sourceTypeId);
                }
            }
        }

        //STEP 2 : Get selector type
        if(sourceTypeIds.length > 0) {
            let result = await Utils.getSourceTypeForParam(sourceTypeIds);
            if(result) {
                for(let row of result) {
                    sourceIds.push({
                        adsNamingSourceId: row.id,
                        adsNamingId: row.adsNamingId,
                        name: row.name,
                        inputType: null
                    });
                }
            }
        }

        //STEP 4 : Get for params
        if(adsNaming.length > 0) {
            adsNaming.map(async (row, index) => {
                let value = '';
                let inputText = "sourceTypeText[" + row.id + "]";
                let textSourceTypeIds = document.getElementsByName(inputText);
                if(textSourceTypeIds && textSourceTypeIds[0]) {
                    value = textSourceTypeIds[0].value;
                    if(value.length > 0 || row.inputType === Utils.ADSNAMING_TYPE_SLUG_SPECIAL) {
                        textParams.push({
                            adsNamingSourceId: null,
                            adsNamingId: row.id,
                            text: value,
                            inputType: row.inputType
                        });
                    }
                }
                else {
                    if(row.inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                        if(kolIds) {
                            let find = kolIds.find(kol => {
                                if(kol.adsNamingId === row.id) {
                                    return kol;
                                }
                            });
                            if(find && find.name) {
                                textParams.push({
                                    adsNamingSourceId: find.adsNamingSourceId,
                                    adsNamingId: row.id,
                                    text: find.name,
                                    inputType: row.inputType
                                });
                            }
                        }
                    }
                    else {
                        let find = sourceIds.find(rs => {
                            if(parseInt(rs.adsNamingId) === parseInt(row.id)) {
                                return rs;
                            }
                        });
                        if(find && find.name) {
                            textParams.push({
                                adsNamingSourceId: find.adsNamingSourceId,
                                adsNamingId: row.id,
                                text: find.name,
                                inputType: null
                            });
                        }
                    }
                }
            });
        }

        return {params: null, data: textParams, success: sourceTypeAllIds.length === selectSourceTypeIds.length};
    }

    return (
        <>
            <div className="row g-3 border rounded bg-light p-2 mt-0 mb-3">
                <div className="col-12 mt-1">
                    <label htmlFor="name" className="form-label">ชื่อ Group Campaign <span className="text-danger">*</span></label>
                    <input type="text" className="form-control" id="name" ref={refName} maxLength={100} />
                </div>
            </div>
            <div className="row g-3 border rounded bg-light p-2 my-3">
                <div className="col-12 mt-1">
                    <label htmlFor="agency" className="form-label">Agency <span className="text-danger">*</span></label>
                    <Select
                        classNamePrefix="form-select-search"
                        options={agency}
                        onChange={(event) => onChangeAgencyId(event)}
                        value={agencyId}
                        getOptionValue={(option) => `${option.id}`}
                        getOptionLabel={(option) => `${option.slug}`}
                    />
                </div>
            </div>

            <div className="row g-3 border rounded bg-light p-2 my-3">
                <div className="col-12 mt-1">
                    <label htmlFor="platformId" className="form-label">Platform</label>
                    <Select
                        classNamePrefix="form-select-search"
                        options={platform}
                        onChange={(event) => onChangePlatformId(event)}
                        value={platformId}
                        getOptionValue={(option) => `${option.id}`}
                        getOptionLabel={(option) => `${option.name}`}
                    />
                </div>
            </div>

            <div className="row g-3 border rounded bg-yellow-light p-2 my-3">
                {
                    adsNaming.length <= 0 ? (<p>ไม่พบข้อมูล Ads Naming</p>) :
                        adsNaming.map((row, index) => {
                            let inputText = "sourceTypeText["+row.id+"]";
                            let formId = '';
                            let source = row.source;
                            let inputType = row.inputType;
                            let selected = null;

                            if(inputType === Utils.ADSNAMING_TYPE_SLUG_SPECIAL) {
                                formId = 'slug-special';
                                return (
                                    <div key={index}>
                                        <div className="d-block fw-bold">{row.name}</div>
                                        <div className=" css-b62m3t-container"><input className="form-control" type="text" id={formId} name={inputText} disabled={true} /></div>
                                    </div>
                                );
                            }
                            else if(inputType === Utils.ADSNAMING_TYPE_SLUG_PROMOTION) {
                                // -- empty
                            }
                            else if(inputType === Utils.ADSNAMING_TYPE_SLUG_PROJECT) {
                                // -- empty
                            }
                            else if(inputType === Utils.ADSNAMING_TYPE_FREEFORM) {
                                formId = 'freeform';
                                return (
                                    <div key={index}>
                                        <div className="d-block fw-bold">{row.name}</div>
                                        <div className=" css-b62m3t-container"><input className="form-control" type="text" id={formId} name={inputText} defaultValue={itemFreeForm} onKeyUp={e => {
                                            if(e && e.target.value) {
                                                e.target.value = Utils.utmSlug(e.target.value);
                                            }
                                        }} /></div>
                                    </div>
                                );
                            }
                            else if(inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                                selected = source.filter(e => e.name === 'none')[0];
                                for(let cs of source) {
                                    let id = cs.id;
                                    let sp = id.split(':KOL');
                                    let kol = parseInt(sp[0]) +':KOL'+ parseInt(row.id);
                                    if(itemSelected.length && itemSelected.includes(kol)) {
                                        selected = {id: id, name: cs.name};
                                        break;
                                    }
                                }
                                return (
                                    <div key={index}>
                                        <div className="d-block fw-bold">{row.name} <span className="text-danger">*</span></div>
                                        <div className=" css-b62m3t-container">
                                            <Select
                                                name="sourceTypeIds[]"
                                                classNamePrefix="form-select-search"
                                                options={source}
                                                defaultValue={selected}
                                                getOptionValue={(option) => `${option.id}`}
                                                getOptionLabel={(option) => `${option.name}`}
                                            />
                                        </div>
                                    </div>
                                );
                            }
                            else {

                                if(row.name === 'Agency' || row.name === 'AgencyMaster') {
                                    if(roles.agencyId && agency) {
                                        let ag = agency.filter(e => e.id === roles.agencyId)[0];
                                        selected = source.filter(e => e.name === ag.slug);
                                    }
                                }
                                else if(itemSelected.length) {
                                    for(let cs of source) {
                                        let id = cs.id;
                                        if(itemSelected.includes(id)) {
                                            selected = {id: id, name: cs.name};
                                            break;
                                        }
                                    }
                                }

                                if(row.name !== 'BG' && row.name !== 'AgencyMaster') {
                                    source = platformId ? source.filter(o => o.platform.some(e => e.adsPlatformId === platformId.id)) : source;
                                }

                                return (
                                    <div key={index}>
                                        <div className="d-block fw-bold">{row.name} <span className="text-danger">*</span></div>
                                        <Select
                                            name="sourceTypeIds[]"
                                            classNamePrefix="form-select-search"
                                            options={source}
                                            defaultValue={selected}
                                            getOptionValue={(option) => `${option.id}`}
                                            getOptionLabel={(option) => `${option.name}`}
                                        />
                                    </div>
                                );
                            }
                        })
                }
            </div>

            <div className="row g-3 mb-3">
                <div className="col-12">
                    <label htmlFor="statusx" className="form-label">สถานะ</label>
                    <div className="form-check form-switch">
                        <input className="form-check-input" type="checkbox" name="statusChecked" id="status" checked={statusChecked} onChange={e => {setStatusChecked(e.target.checked)}} />
                        <label className="form-check-label" htmlFor="status"></label>
                    </div>
                </div>
            </div>

            <div className="row g-3">
                <div className="col-12">
                    <button type="button" className="btn btn-primary" onClick={onCreate} disabled={isLoading}><span
                        className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isLoading ? btnTextLoading : btnTextDefault}</button>
                    <NavLink className="btn btn-sm btn-light ms-2" to={props.backPath}><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                    <Toaster position="bottom-right" />
                </div>
            </div>
        </>
    );
} 